module.exports = __webpack_public_path__ + "img/chestGame.5496ec50.png";